import { render, staticRenderFns } from "./ForgotPasswordSecurityQuestions.vue?vue&type=template&id=338b14a2&scoped=true&"
import script from "./ForgotPasswordSecurityQuestions.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordSecurityQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordSecurityQuestions.vue?vue&type=style&index=0&id=338b14a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b14a2",
  null
  
)

export default component.exports